import { ServiceSchedules } from '@/service/schedules/serviceSchedules'

const serviceSchedules = new ServiceSchedules()

export default {
  namespaced: true,
  state: {
    loading: false,
    refundValue: null,
    error: null,
  },
  getters: {
    loading: state => state.loading,
    refundValue: state => state.refundValue,
    error: state => state.error,
  },
  mutations: {
    UPDATE_LOADING(state, val) {
      state.loading = val
    },
    SET_REFUND_VALUE(state, value) {
      state.refundValue = value
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    CLEAR_ERROR(state) {
      state.error = null
    },
  },
  actions: {
    async valueRefundService({ commit }, id) {
      commit('UPDATE_LOADING', true)
      commit('CLEAR_ERROR')
      try {
        const response = await serviceSchedules.valueRefundService(id)
        commit('SET_REFUND_VALUE', response.credit_card)
      } catch (error) {
        commit('SET_ERROR', error.message || 'Erro ao buscar valor do reembolso')
        throw error
      } finally {
        commit('UPDATE_LOADING', false)
      }
    },

    async cancelByWallet({ commit }, id, userProfile) {
      commit('UPDATE_LOADING', true)
      commit('CLEAR_ERROR')

      try {
        const response = await serviceSchedules.cancelByWallet(id, userProfile)
        commit('SET_REFUND_VALUE', response.credit_card)
      } catch (error) {
        commit('SET_ERROR', error.message || 'Erro ao buscar valor do reembolso')
        throw error
      } finally {
        commit('UPDATE_LOADING', false)
      }
    },

    async refundService({ commit }, id) {
      commit('UPDATE_LOADING', true)
      commit('CLEAR_ERROR')
      try {
        await serviceSchedules.refundService(id)
        commit('SET_REFUND_VALUE', null)
      } catch (error) {
        commit('SET_ERROR', error.message || 'Erro ao processar o reembolso')
        throw error
      } finally {
        commit('UPDATE_LOADING', false)
      }
    },
    async refundSpeacilistAndCustomerService({ commit }, payload) {
      commit('UPDATE_LOADING', true)
      commit('CLEAR_ERROR')
      try {
        if (payload.role === 'customer') {
          await serviceSchedules.refundCustomerCancelService(payload)
        } else if (payload.role === 'specialist') {
          await serviceSchedules.refundSpecialistCancelService(payload)
        }
        commit('SET_REFUND_VALUE', null)
      } catch (error) {
        commit('SET_ERROR', error.message || 'Erro ao processar o reembolso')
        throw error
      } finally {
        commit('UPDATE_LOADING', false)
      }
    },
    async refundPaymentReversalService({ commit }, payload) {
      commit('UPDATE_LOADING', true)
      commit('CLEAR_ERROR')
      try {
        await serviceSchedules.refundPaymentReversalPerCustomer(payload)
        commit('SET_REFUND_VALUE', null)
      } catch (error) {
        commit('SET_ERROR', error.message || 'Erro ao processar o reembolso')
        throw error
      } finally {
        commit('UPDATE_LOADING', false)
      }
    },
  },
}
